// Entry module: registers the <vf-apy-chart> custom element.
//
// Embed:
//   <script type="module" src="vf-apy-chart.js"></script>
//   <vf-apy-chart api-base="https://example.com"></vf-apy-chart>

import { VfApyChart } from "./vf-apy-chart";
import { VfIncomeExplorer } from "./vf-income-explorer";

if (customElements.get("vf-apy-chart") === undefined) {
  customElements.define("vf-apy-chart", VfApyChart);
}
if (customElements.get("vf-income-explorer") === undefined) {
  customElements.define("vf-income-explorer", VfIncomeExplorer);
}

export { VfApyChart, VfIncomeExplorer };
